import 'app/agriculture/components/Title/Title.scss';
import { LogoIcon } from 'app/agriculture/icons';

interface TitleProps {
    children: string;
}

export function Title({ children }: TitleProps) {
    return (
        <div className="Title">
            <LogoIcon className="Title__logo" size={24} />
            <h1 className="Title__text">{children}</h1>
        </div>
    );
}
